import React, { useState } from 'react';

function Warehouse() {
  const [items, setItems] = useState([
    { id: 1, name: 'Доска дубовая', sku: 'WOOD-001', quantity: 150, unit: 'м²', minStock: 50, price: 850, supplier: 'ООО ЛесПром' },
    { id: 2, name: 'Саморезы 4×40', sku: 'SCR-004', quantity: 2000, unit: 'шт', minStock: 500, price: 1.2, supplier: 'ООО Крепёж' },
    { id: 3, name: 'Ткань обивка серая', sku: 'FAB-012', quantity: 80, unit: 'м', minStock: 30, price: 450, supplier: 'ИП Текстиль' },
    { id: 4, name: 'ЛДСП 16мм белый', sku: 'LDSP-016', quantity: 25, unit: 'лист', minStock: 10, price: 1200, supplier: 'ООО МебельКомплект' },
    { id: 5, name: 'Кромка ПВХ 0.4мм', sku: 'EDGE-004', quantity: 300, unit: 'м', minStock: 100, price: 35, supplier: 'ООО Кромка' },
  ]);

  const [purchases, setPurchases] = useState([
    { id: 1, item: 'ЛДСП 16мм белый', quantity: 15, date: '2026-06-10', supplier: 'ООО МебельКомплект', total: 18000, status: 'В пути' },
    { id: 2, item: 'Ткань обивка серая', quantity: 50, date: '2026-06-12', supplier: 'ИП Текстиль', total: 22500, status: 'Заказано' },
    { id: 3, item: 'Саморезы 4×40', quantity: 1000, date: '2026-06-08', supplier: 'ООО Крепёж', total: 1200, status: 'Получено' },
  ]);

  return (
    <div>
      <h2>🏭 Склад и снабжение</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 20 }}>
        Управление запасами и закупками
      </p>

      {/* Складские остатки */}
      <h3 style={{ marginBottom: 10 }}>📦 Текущие остатки</h3>
      <div style={{ overflowX: 'auto', marginBottom: 24 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
              <th style={{ padding: 6 }}>Название</th>
              <th style={{ padding: 6 }}>Артикул</th>
              <th style={{ padding: 6, textAlign: 'right' }}>Кол-во</th>
              <th style={{ padding: 6 }}>Ед.</th>
              <th style={{ padding: 6, textAlign: 'right' }}>Мин. запас</th>
              <th style={{ padding: 6 }}>Статус</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
                <td style={{ padding: 6 }}>{item.name}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{item.sku}</td>
                <td style={{ padding: 6, textAlign: 'right' }}>{item.quantity}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{item.unit}</td>
                <td style={{ padding: 6, textAlign: 'right', color: '#94A3B8' }}>{item.minStock}</td>
                <td style={{ padding: 6 }}>
                  <span style={{ color: item.quantity <= item.minStock ? '#EF4444' : '#10B981', fontSize: 12 }}>
                    {item.quantity <= item.minStock ? '⚠️ Мало' : '✅ Норма'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Закупки */}
      <h3 style={{ marginBottom: 10 }}>🛒 Заказы на закупку</h3>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
              <th style={{ padding: 6 }}>Товар</th>
              <th style={{ padding: 6, textAlign: 'right' }}>Кол-во</th>
              <th style={{ padding: 6 }}>Дата</th>
              <th style={{ padding: 6 }}>Поставщик</th>
              <th style={{ padding: 6, textAlign: 'right' }}>Сумма</th>
              <th style={{ padding: 6 }}>Статус</th>
            </tr>
          </thead>
          <tbody>
            {purchases.map((p, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
                <td style={{ padding: 6 }}>{p.item}</td>
                <td style={{ padding: 6, textAlign: 'right' }}>{p.quantity}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{p.date}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{p.supplier}</td>
                <td style={{ padding: 6, textAlign: 'right' }}>{p.total.toLocaleString()} ₽</td>
                <td style={{ padding: 6 }}>
                  <span style={{
                    color: p.status === 'Получено' ? '#10B981' : p.status === 'В пути' ? '#F59E0B' : '#94A3B8',
                    fontSize: 12,
                  }}>
                    {p.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Warehouse;